var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonTempered91878Cdb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.457 11.2825C16.285 11.0185 17.167 10.876 18.082 10.876C22.8453 10.876 26.707 14.7377 26.707 19.501C26.707 21.6505 25.921 23.6162 24.6205 25.126",
    stroke: "#4DBB3E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.543 25.124C10.2425 23.6135 9.45647 21.6478 9.45647 19.499C9.45647 18.584 9.59897 17.702 9.86297 16.874",
    stroke: "#4DBB3E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.082 21.751C16.8394 21.751 15.832 20.7436 15.832 19.501C15.832 18.2583 16.8394 17.251 18.082 17.251C19.3247 17.251 20.332 18.2583 20.332 19.501C20.332 20.7436 19.3247 21.751 18.082 21.751Z",
    fill: "#0F0F10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2695 13.6875L18.082 19.5",
    stroke: "#0F0F10",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.683 30.374H9.48178C6.27253 27.833 4.20703 23.9105 4.20703 19.499C4.20703 11.8363 10.4193 5.62402 18.082 5.62402C25.7448 5.62402 31.957 11.8363 31.957 19.499C31.957 23.9105 29.8915 27.833 26.683 30.374Z",
    stroke: "#0F0F10",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonTempered91878Cdb);
export default __webpack_public_path__ + "static/media/non-tempered.91878cdb.454ce04e2f6afc0f60ac5f4b5602ffda.svg";
export { ForwardRef as ReactComponent };